import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { GoogleSignIn } from '../components/GoogleSignIn';
import { ShoppingCart } from 'lucide-react';

export const Login: React.FC = () => {
  const { login } = useAuth();
  const [error, setError] = useState('');

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 sm:space-y-8">
        <div className="text-center">
          <div className="flex justify-center">
            <ShoppingCart className="h-10 w-10 sm:h-12 sm:w-12 text-primary" />
          </div>
          <h2 className="mt-4 sm:mt-6 text-2xl sm:text-3xl font-extrabold text-foreground">
            Agent Shopper
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            AI-powered product discovery and shopping assistance
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Welcome to Agent Shopper</CardTitle>
            <CardDescription>
              Sign in to start discovering products with AI agents
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {error && (
              <div className="text-red-600 text-sm text-center">
                {error}
              </div>
            )}

            {/* Google OAuth Button */}
            <GoogleSignIn 
              onSuccess={(user) => {
                // The callback handler will redirect to dashboard
              }}
              onError={(error) => {
                setError(error);
              }}
              className="w-full"
            />
          </CardContent>
        </Card>

        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};
